document.addEventListener('DOMContentLoaded', function() {
  try {
    console.debug('[LandingFeaturedProduct] DOMContentLoaded');
  } catch (_) {}
  // Initialize mobile swiper
  try {
    initMobileSwiper();
  } catch (e) {
    console.error('[LandingFeaturedProduct] initMobileSwiper failed:', e);
  }

  // Initialize buy option selection with a small delay to ensure DOM is ready
  setTimeout(() => {
    try {
      initBuyOptionSelection();
    } catch (e) {
      console.error('[LandingFeaturedProduct] initBuyOptionSelection failed:', e);
    }
  }, 100);

  // Initialize modal functionality
  try {
    initModalFunctionality();
  } catch (e) {
    console.error('[LandingFeaturedProduct] initModalFunctionality failed:', e);
  }

  // Initialize collapsible functionality
  try {
    initCollapsibleFunctionality();
  } catch (e) {
    console.error('[LandingFeaturedProduct] initCollapsibleFunctionality failed:', e);
  }

  // Initialize timers
  try {
    initTimers();
  } catch (e) {
    console.error('[LandingFeaturedProduct] initTimers failed:', e);
  }

  // Initialize product form
  try {
    initProductForm();
  } catch (e) {
    console.error('[LandingFeaturedProduct] initProductForm failed:', e);
  }
});

function initMobileSwiper() {
  const mobileGallery = document.querySelector('.mobile-gallery-swiper');
  if (!mobileGallery) return;
  if (typeof Swiper === 'undefined') {
    console.warn('[LandingFeaturedProduct] Swiper not found; skipping mobile gallery init');
    return;
  }

  // Check if we have enough slides for loop
  const slideElements = mobileGallery.querySelectorAll('.swiper-slide');
  const shouldLoop = slideElements.length > 1;

  // Initialize Swiper with optimized settings
  const swiper = new Swiper(mobileGallery, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: shouldLoop,
    loopedSlides: shouldLoop ? 2 : 0,
    grabCursor: true,
    allowTouchMove: true,
    speed: 400,
    effect: 'slide',
    width: null,
    // Remove autoplay completely
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      disabledClass: 'swiper-button-disabled',
    },
    pagination: {
      el: mobileGallery.querySelector('.swiper-pagination'),
      clickable: true,
      type: 'bullets',
    },
    // Optimized transitions
    on: {
      init: function() {
        mobileGallery.classList.add('swiper-initialized');
        this.el.style.opacity = '1';
        this.el.style.transform = 'translateY(0)';
        
        // Force correct width calculation
        this.updateSize();
        this.updateSlidesClasses();
        
        // Ensure first slide is properly loaded
        setTimeout(() => {
          this.update();
        }, 100);
      },
      slideChange: function() {
        // Simplified transition effects
        const activeSlide = this.slides[this.activeIndex];
        if (activeSlide) {
          activeSlide.style.transform = 'scale(1.01)';
          setTimeout(() => {
            activeSlide.style.transform = 'scale(1)';
          }, 200);
        }
      },
      touchStart: function() {
        mobileGallery.classList.add('swiper-touch');
      },
      touchEnd: function() {
        mobileGallery.classList.remove('swiper-touch');
      },
      resize: function() {
        // Handle resize properly
        this.updateSize();
        this.updateSlidesClasses();
      }
    }
  });

  // Add smooth hover effects to navigation buttons
  const navButtons = mobileGallery.querySelectorAll('.swiper-button-next, .swiper-button-prev');
  navButtons.forEach(button => {
    button.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-50%) scale(1.1)';
      this.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(-50%) scale(1)';
    });
  });

  // Add smooth slide transitions
  const allSlides = mobileGallery.querySelectorAll('.swiper-slide');
  allSlides.forEach(slide => {
    slide.style.transition = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
  });

  // Add touch feedback
  mobileGallery.addEventListener('touchstart', function() {
    this.classList.add('swiper-touch');
  });

  mobileGallery.addEventListener('touchend', function() {
    setTimeout(() => {
      this.classList.remove('swiper-touch');
    }, 300);
  });
}


function initBuyOptionSelection() {
  const buyOptions = document.querySelectorAll('.landing-featured-product__buy-option');
  const addToCartForm = document.querySelector('.product-form form[data-type="add-to-cart-form"]');
  const variantInput = addToCartForm ? addToCartForm.querySelector('input[name="id"]') : null;
  const addToCartButton = document.querySelector('.add-to-cart-btn');
  const currentVariantDisplay = document.querySelector('.landing-featured-product__current-variant');
  
  if (!buyOptions.length) {
    console.warn('[LandingFeaturedProduct] No buy options found in DOM');
    // Add delegated click listener for debugging even if options are injected later
    const optionsContainer = document.querySelector('.landing-featured-product__buy-options-options');
    if (optionsContainer) {
      optionsContainer.addEventListener('click', function(e) {
        const option = e.target.closest('.landing-featured-product__buy-option');
        if (!option) return;
        console.debug('[LandingFeaturedProduct] Delegated click captured', {
          variantId: option.dataset.variantId,
          title: option.dataset.variantTitle
        });
      });
    }
    return;
  }
  console.debug('[LandingFeaturedProduct] initBuyOptionSelection: found', buyOptions.length, 'options');
  
  // Select first option by default and update form
  if (buyOptions.length > 0) {
    const firstOption = buyOptions[0];
    firstOption.classList.add('selected');
    updateSelectedVariant(firstOption);
    console.debug('[LandingFeaturedProduct] Default selected option set', {
      variantId: firstOption.dataset.variantId,
      title: firstOption.dataset.variantTitle
    });
  }
  
  buyOptions.forEach(option => {
    option.addEventListener('click', function() {
      // Only proceed if this option is not already selected
      if (this.classList.contains('selected')) return;
      console.debug('[LandingFeaturedProduct] Clicked buy option', {
        variantId: this.dataset.variantId,
        title: this.dataset.variantTitle,
        price: this.dataset.variantPrice,
        compareAtPrice: this.dataset.variantComparePrice,
        available: this.dataset.variantAvailable
      });
      
      // Remove selected class from all options
      buyOptions.forEach(opt => opt.classList.remove('selected'));
      
      // Add selected class to clicked option
      this.classList.add('selected');
      
      // Update selected variant
      updateSelectedVariant(this);
      
      // Publish variant change event for other components
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
        const variantId = this.dataset.variantId;
        const variantTitle = this.dataset.variantTitle;
        const variantPrice = this.dataset.variantPrice;
        const variantComparePrice = this.dataset.variantComparePrice;
        
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            variant: {
              id: parseInt(variantId),
              title: variantTitle,
              price: parseInt(variantPrice),
              compare_at_price: variantComparePrice ? parseInt(variantComparePrice) : null
            },
            sectionId: document.querySelector('[data-section-id]') ? document.querySelector('[data-section-id]').dataset.sectionId : null
          }
        });
      }
    });
  });

  // Also set up delegated listener as a fallback
  const optionsContainer = document.querySelector('.landing-featured-product__buy-options-options');
  if (optionsContainer) {
    optionsContainer.addEventListener('click', function(e) {
      const option = e.target.closest('.landing-featured-product__buy-option');
      if (!option) return;
      if (option.classList.contains('selected')) return;
      console.debug('[LandingFeaturedProduct] Delegated click switching option', {
        variantId: option.dataset.variantId,
        title: option.dataset.variantTitle
      });
      document.querySelectorAll('.landing-featured-product__buy-option').forEach(opt => opt.classList.remove('selected'));
      option.classList.add('selected');
      updateSelectedVariant(option);
    });
  }
  
  function updateSelectedVariant(selectedOption) {
    if (!selectedOption) return;
    
    const variantId = selectedOption.dataset.variantId;
    const variantPrice = selectedOption.dataset.variantPrice;
    const variantComparePrice = selectedOption.dataset.variantComparePrice;
    const variantTitle = selectedOption.dataset.variantTitle;
    const isAvailable = selectedOption.dataset.variantAvailable === 'true';
    console.debug('[LandingFeaturedProduct] updateSelectedVariant', {
      variantId,
      variantTitle,
      variantPrice,
      variantComparePrice,
      isAvailable
    });
    
    // Update variant input in form
    if (variantInput && variantId) {
      variantInput.value = variantId;
    } else if (!variantInput) {
      console.warn('[LandingFeaturedProduct] Variant input not found in form');
    }
    
    // Update button state and text
    if (addToCartButton) {
      const buttonTextPrice = addToCartButton.querySelector('.button-text-price');
      const buttonStockText = addToCartButton.querySelector('.button-stock-text');
      const variantPriceSpan = addToCartButton.querySelector('.variant-price');
      
      // Update button availability
      addToCartButton.disabled = !isAvailable;
      
      // Update price in button
      if (variantPriceSpan && variantPrice) {
        const priceFormatted = formatMoney(parseInt(variantPrice));
        variantPriceSpan.textContent = `- ${priceFormatted}`;
      }
      
      // Update stock text
      if (buttonStockText) {
        if (isAvailable) {
          buttonStockText.textContent = buttonStockText.dataset.inStock || 'In Stock: Ready to Ship';
        } else {
          buttonStockText.textContent = 'Sold Out';
        }
      }
    }
    
    // Update pricing display at top
    const pricingSection = document.querySelector('.landing-featured-product__buy-options-pricing');
    if (pricingSection) {
      const currentPriceSpan = pricingSection.querySelector('.current-price');
      const comparePriceSpan = pricingSection.querySelector('.compare-price');
      
      if (currentPriceSpan && variantPrice) {
        currentPriceSpan.textContent = formatMoney(parseInt(variantPrice));
      }
      
      if (comparePriceSpan) {
        if (variantComparePrice && parseInt(variantComparePrice) > parseInt(variantPrice)) {
          comparePriceSpan.textContent = formatMoney(parseInt(variantComparePrice));
          comparePriceSpan.style.display = 'inline';
        } else {
          comparePriceSpan.style.display = 'none';
        }
      }
    }
    
    // Update heading text based on selected option
    const headingElement = document.querySelector('.landing-featured-product__buy-options-heading h2');
    if (headingElement) {
      const selectedTitle = selectedOption.querySelector('.landing-featured-product__buy-option-content-title');
      if (selectedTitle) {
        const optionText = selectedTitle.textContent.trim();
        let headingText = 'Choose your Pack: ';
        
        if (optionText.includes('Fast Relief')) {
          headingText += 'Buy 1';
        } else if (optionText.includes('Most Popular')) {
          headingText += 'Buy 2';
        } else if (optionText.includes('Best Results')) {
          headingText += 'Buy 3';
        } else {
          headingText += optionText;
        }
        
        headingElement.textContent = headingText;
      }
    }
  }
  
  // Simple money formatting function (fallback if Shopify's isn't available)
  function formatMoney(cents) {
    // Normalize input to integer cents
    let valueInCents = 0;
    try {
      if (typeof cents === 'string') {
        if (cents.includes('.')) {
          valueInCents = Math.round(parseFloat(cents) * 100);
        } else {
          valueInCents = parseInt(cents, 10);
        }
      } else if (typeof cents === 'number') {
        valueInCents = Math.round(cents);
      } else if (cents && typeof cents === 'object' && 'amount' in cents) {
        valueInCents = Math.round(parseFloat(cents.amount) * 100);
      }
    } catch (_) {
      valueInCents = 0;
    }

    // Use Shopify's formatter if present, always provide a format string
    try {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        const format = (Shopify.money_format || (window.theme && window.theme.moneyFormat) || '${{amount}}');
        return Shopify.formatMoney(valueInCents, format);
      }
    } catch (e) {
      console.warn('[LandingFeaturedProduct] Shopify.formatMoney failed, falling back:', e);
    }

    // Fallback formatting
    const dollars = (valueInCents / 100).toFixed(2);
    return `$${dollars}`;
  }
}

function initModalFunctionality() {
  const modalTriggers = document.querySelectorAll('.modal-trigger');
  const modals = document.querySelectorAll('.custom-modal');
  
  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const modalId = this.dataset.modalId;
      const modal = document.getElementById(modalId);
      
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
  });
  
  modals.forEach(modal => {
    const closeBtn = modal.querySelector('.custom-modal__close');
    const overlay = modal.querySelector('.custom-modal__overlay');
    
    // Close on close button click
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        closeModal(modal);
      });
    }
    
    // Close on overlay click
    if (overlay) {
      overlay.addEventListener('click', function() {
        closeModal(modal);
      });
    }
    
    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal(modal);
      }
    });
  });
  
  function closeModal(modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }
}

function initCollapsibleFunctionality() {
  const collapsibleRows = document.querySelectorAll('.landing-featured-product__collabsible-row');
  
  collapsibleRows.forEach(row => {
    const heading = row.querySelector('.landing-featured-product__collabsible-heading');
    const icon = row.querySelector('.landing-featured-product__collabsible-icon img');
    
    if (heading) {
      heading.addEventListener('click', function() {
        row.classList.toggle('active');
        
        // Switch between plus and minus icons based on state
        if (icon) {
          if (row.classList.contains('active')) {
            // Show minus icon when expanded
            if (icon.src.includes('plus-icon.svg')) {
              icon.src = icon.src.replace('plus-icon.svg', 'minus.svg');
            }
            icon.alt = 'Minus';
          } else {
            // Show plus icon when collapsed
            if (icon.src.includes('minus.svg')) {
              icon.src = icon.src.replace('minus.svg', 'plus-icon.svg');
            }
            icon.alt = 'Plus';
          }
        }
      });
    }
  });
}

function initTimers() {
  const timerElements = document.querySelectorAll('[data-timer]');
  
  timerElements.forEach(timerElement => {
    const buyOptionElement = timerElement.closest('.landing-featured-product__buy-option');
    if (!buyOptionElement) return;
    
    const optionId = buyOptionElement.dataset.optionId;
    if (!optionId) return;
    
    const storageKey = `timer_${optionId}`;
    
    // Get saved time or set default (10 minutes)
    let savedTime = localStorage.getItem(storageKey);
    let totalSeconds = savedTime ? parseInt(savedTime) : 600; // 10 minutes in seconds
    
    function updateTimer() {
      if (totalSeconds <= 0) {
        // Timer finished, restart
        totalSeconds = 600;
        localStorage.setItem(storageKey, totalSeconds.toString());
      }
      
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      
      const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      timerElement.textContent = timeString;
      
      totalSeconds--;
      localStorage.setItem(storageKey, totalSeconds.toString());
    }
    
    // Update timer immediately
    updateTimer();
    
    // Update timer every second
    setInterval(updateTimer, 1000);
  });
}

// Initialize product form with proper Shopify functionality
function initProductForm() {
  const productForm = document.querySelector('product-form.product-form');
  if (!productForm) return;

  // The product-form custom element will handle the form submission automatically
  // We just need to listen for cart updates and handle the response appropriately
  
  // Listen for successful cart additions
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'product-form') {
        // Handle successful cart addition
        handleCartUpdate(event);
      }
    });
    
    subscribe(PUB_SUB_EVENTS.cartError, (event) => {
      if (event.source === 'product-form') {
        // Handle cart errors
        console.error('Cart error:', event.message);
      }
    });
  }
}

function handleCartUpdate(event) {
  // Update cart count in header
  updateCartCount(event.cartData);
  
  // Force cart notification to show (overriding page redirect)
  if (event.cartData) {
    // Find and show cart notification if it exists
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
      // Show the cart notification popup
      cartNotification.renderContents(event.cartData);
    }
    
    // Find and show cart drawer if that's the preferred method
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && !cartNotification) {
      cartDrawer.renderContents(event.cartData);
    }
    
    // Trigger cart icon update
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon && event.cartData.item_count) {
      const cartCountBubble = cartIcon.querySelector('.cart-count-bubble');
      const cartCountText = cartIcon.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      
      if (event.cartData.item_count > 0) {
        if (!cartCountBubble) {
          // Create cart count bubble if it doesn't exist
          const bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = `<span aria-hidden="true">${event.cartData.item_count}</span>`;
          cartIcon.appendChild(bubble);
        } else if (cartCountText) {
          cartCountText.textContent = event.cartData.item_count;
        }
      }
    }
  }
}

function updateCartCount(cartData) {
  if (!cartData) return;
  
  // Update cart icon in header
  const cartIconBubble = document.querySelector('#cart-icon-bubble');
  if (cartIconBubble) {
    const countElement = cartIconBubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (countElement && cartData.item_count !== undefined) {
      countElement.textContent = cartData.item_count;
    }
  }
}

